<template>
    <span v-if="mostrarBtn">
        <span class="text-primary ml-1">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Observações"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="preencher()">
            <div slot="modal-title">Pagamento - Atualizar Observações</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Observações</label>
                        <b-form-textarea
                            v-model="observacoes"
                            :rows="4"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="confirmar()"
                    class="ml-2"
                >
                    <span> <i class="fa fa-edit"></i> Salvar</span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            observacoes: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        preencher() {
            this.observacoes = this.pagamento.observacoes
        },

        fecharModal() {
            this.mostrarModal = false
            this.observacoes = null
            this.erros = []
        },

        confirmar() {
            this.$swal({
                title: 'Atualizar Observações',
                html: `Confirma a atualização das observações do pagamento de protocolo ${this.pagamento.protocolo}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.atualizar()
                }
            })
        },

        atualizar() {
            this.$store.dispatch('addRequest')
            let pagamentoDto = {
                pagamentoId: this.$route.params.pagamentoId,
                observacoes: this.observacoes
            }
            this.pagamentosServicos
                .atualizarObservacoes(pagamentoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.fecharModal()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('CONT-PAG-09') &&
                this.pagamento.status != pagamentoStatus.CRIADO &&
                this.pagamento.status != pagamentoStatus.REPROVADO
            )
        }
    }
}
</script>
